  $(document).ready(function(){
        //Breed Select2
        var $search_breed_select = $('#search-breed__select');
        $search_breed_select.select2({
          allowClear: true
        });

     
        $search_breed_select.on("select2:select", function (e) { 
          var selected_breed = $(this).val();
          
          if(selected_breed){
            $('#breed_label').text(selected_breed);
            //Filter Breed  
            $('.tabs__panel-body-breeds').show();
            var tables_rows = $('.tabs__panel-body-breeds').find('.size-table-wrapper table tbody tr');
            $(tables_rows).each(function(){
              var td = $(this).children('td').eq(1);
              if(td){
                var td_content = $(td).text();
                if(td_content.includes(selected_breed)){
                  $(this).show();
                } else {
                  $(this).hide();
                }
              }
            });
          }
        });
        
        $search_breed_select.on("select2:clear", function (e) { 
          $('.tabs__panel-body-breeds').hide();
        });
        
        
        $('.toggle-button__input_measurements').change(function(){
          var to_show_table_unit = $(this).val();
          var panel_body = $(this).closest('.tabs__panel-body');
          var table_wrappers = $(panel_body).find('.size-table-wrapper');
          $(table_wrappers).each(function(){
            var unit = $(this).attr('data-size-unit');
            if(unit == to_show_table_unit){
              $(this).show();
            } else {
              $(this).hide();
            }
          });
        });
        
        $('.toggle-button__input_breeds').change(function(){
          var to_show_table_unit = $(this).val();
          var panel_body = $(this).closest('.tabs__panel-body');
          var table_wrappers = $(panel_body).find('.size-table-wrapper');
          $(table_wrappers).each(function(){
            var unit = $(this).attr('data-size-unit');
            if(unit == to_show_table_unit){
              $(this).show();
            } else {
              $(this).hide();
            }
          });
        });
        
      })
     
      document.addEventListener("DOMContentLoaded", function(event) { 
         event.preventDefault();
        function size_guide_tab_click_handler() {
          document.querySelectorAll('.tabs__header .tabs__button').forEach(item => {
            item.classList.remove('is-active');
          });
          this.classList.add('is-active');
          var tab_id = this.getAttribute("data-tab");
          document.querySelectorAll('.tabs__body .tabs__panel').forEach(item => {
            item.classList.remove('is-active');
            if (item.id == tab_id) {
              item.classList.add('is-active');
            }
          });
          
        }
        // Bind Click Event on Tab Header
        document.querySelectorAll('.tabs__header .tabs__button').forEach(item => {
          item.addEventListener('click', size_guide_tab_click_handler);
        });
        if(false){
          $("#size-by-measurements-cm, #size-by-breeds-kg").prop("checked",true);
          $("#size-by-measurements-in, #size-by-breeds-lbs").prop("checked",false);
          $(".size-table-wrapper.by-cm, .size-table-wrapper.by-kg").css("display", "block");
          $(".size-table-wrapper.by-in, .size-table-wrapper.by-lbs").css("display", "none");
        }
                
      });


      // Go to size chart section
      $(document).on('click', '.size_chart_section', function (event) {
          event.preventDefault();
          $('html, body').animate({
              scrollTop: $($.attr(this, 'href')).offset().top + -150
          }, 1000);
      });

    //  product page accodions
      $(".accordion_item > .title_tab").click(function() {
          $(this).toggleClass("active").next('.inner_content').slideToggle(250).closest('.custom-accoridions').siblings().find('.title_tab').removeClass('active').next('.inner_content').slideUp(250);
      });

